<template>
  <div>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>

    <v-dialog v-model="tahsilatdialog" persistent max-width="400px">

      <v-card color="grey lighten-5">
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title class="baslikfont">{{dialogbaslik}}</v-toolbar-title>
          </v-toolbar>
        </v-flex>
        <v-card-text>
          <v-form ref="formTahsilat" v-model="valid" lazy-validation>
            <div class="flex md12">

              <tarihcomp :etiket="$t('Payment-Date')" :rules="[v => !!v || $t('Mandatory-Areas')]" v-bind:defaultvalue="'ok'"
                v-bind:value="odeme.OdemeTarihi" v-model="odeme.OdemeTarihi"></tarihcomp>

              <v-layout row wrap>
                <v-flex sm6 md6 xs6>
                  <v-select hide-details item-text="text" item-value="value" :label="$t('Payment-Type')"
                    v-model="odeme.OdemeTipi" :items="odemeItems" ></v-select>
                </v-flex>
                <v-flex sm6 md6 xs6>
                  <v-text-field hide-details="" :label="$t('Document-No')" v-model="odeme.EvrakNo"></v-text-field>
                </v-flex>
              </v-layout>

              <kur :rules="[v => !!v || $t('Mandatory-Areas')]" v-model="para" :kurtarihi="odeme.OdemeTarihi"></kur>
              <parainput :etiket="$t('Amount')" :simge="getparabirimi()" v-model="odeme.Tutar"
                :autocomplete="'autocomplete'" ></parainput>

              <v-flex sm12 md12 xs12>
                <!-- <v-form ref="formkarsicari" v-model="validkarsicari" lazy-validation> -->
                  <v-layout row wrap>
                    <v-flex sm12 md12 xs12>
                   <cariaracomp v-if="odeme.OdemeTipi==0 || odeme.OdemeTipi==3 || odeme.OdemeTipi==1" v-bind:etiket="this.$t('Counter-Current')" v-bind:value="cariKodu.KarsiCari.kod" v-model="cariKodu.KarsiCari.kod" :Coper="true"></cariaracomp>
                    </v-flex>
                    <v-flex sm12 md12 xs12>
                      <v-text-field hide-details=""
                        v-if="odeme.OdemeTipi==0 || odeme.OdemeTipi==3 || odeme.OdemeTipi==1"
                        v-model="cariKodu.KarsiCariAciklama" :rules="[v => (v == null || v.length <= 250) || 'Max 250']"  :label="$t('Counter-Explanation')"></v-text-field>
                    </v-flex>
                  </v-layout>
                <!-- </v-form> -->
              </v-flex>

              <v-flex sm12 md12 xs12>
                <v-form ref="formkredikarti" v-model="validkredikarti" lazy-validation>
                  <v-layout row wrap>

                    <v-flex sm12 md12 xs12>

                      <v-text-field hide-details=""
                        v-if="odeme.OdemeTipi==1" :label="$t('Credit-Card-No')"
                        v-model="odeme.KrediKartBilgi.KartNo"></v-text-field>
                    </v-flex>
  
                    <v-flex sm12 md12 xs12>

                      <v-select hide-details  :items="karttipi"
                        v-if="odeme.OdemeTipi==1" clearable v-model="odeme.KrediKartBilgi.KartTipi"
                        :label="$t('Credit-Card-Type-v2')" item-text="text" item-value="id"></v-select>
                    </v-flex>
                    <v-flex sm12 md12 xs12>

                      <v-layout>
                        <v-autocomplete :items="bankapositems" v-if="odeme.OdemeTipi==1"
                          @change="taksitgetirtahsilat(odeme.KrediKartBilgi.PosKodu)" hide-details=""
                          v-model="odeme.KrediKartBilgi.PosKodu" item-text="Title" item-value="PosKodu" clearable
                          :label="$t('Bank-Pos-Code')"></v-autocomplete>
                        <v-select :items="taksitsayitahsilat" v-if="odeme.OdemeTipi==1" hide-details=""
                          v-model="odeme.KrediKartBilgi.PosTaksit" item-text="TaksitAciklama" item-value="TaksitID"
                          clearable :label="$t('Instalment')"></v-select>
                      </v-layout>
                    </v-flex>
                    <v-flex sm12 md12 xs12>

                      <v-text-field hide-details="" mask="#########" v-if="odeme.OdemeTipi==1" :label="$t('Score-Amount')"
                        v-model="odeme.KrediKartBilgi.PuanTutari"></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-flex>

              <v-flex v-if="odeme.OdemeTipi==2" sm12 md12 xs12>
                  <v-layout row wrap>
                    <v-flex sm12 md12 xs12>
                      <v-autocomplete :items="itemsbanka" hide-details="" v-model="odeme.HavaleBilgi.Banka"
                        item-text="BankaAdi" item-value="BankaKod" clearable
                        :label="$t('Bank-Code')"></v-autocomplete>
                    </v-flex>
                    <v-flex sm12 md12 xs12>
                      <v-text-field hide-details=""
                        v-model="odeme.HavaleBilgi.Aciklama" :rules="[v => (v == null || v.length <= 100) || $t('Must-be-characters-maximum-v2')]"  :label="$t('Transfer-Explanation')"></v-text-field>
                    </v-flex>
                  </v-layout>
              </v-flex>



              <v-text-field hide-details="" v-model="odeme.Aciklama" :rules="[v => (v == null || v.length <= 250) || 'Max 250 karakter olmalı']" :label="this.$t('EXPLANATION')"></v-text-field>
              <v-checkbox :label="$t('Payment-Return')" v-model="odeme.OdemeIadesi"></v-checkbox>

            </div>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="blue darken-1" flat @click.native="tahsilatdialog=false">{{$t('Cancel')}}</v-btn>
          <div v-show="tahsilatguncellebuton === true">
            <v-btn id="bguncelle" color="blue darken-1" flat @click="tahsilatguncelle()">{{ $t('Update') }}</v-btn>
          </div>
          <div v-show="kaydetbuton===true">
            <v-btn id="bkaydet" color="blue darken-1" flat @click="tahsilatvalidate()">{{$t("save_button")}}</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card>
      <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
        :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
        {{ text1 }}
        <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
      </v-snackbar>
    </v-card>
  </div>
</template>


<script>
  import auth from '../../../../api/auth'
  import tarihcomp from '../../customcomp/tarihim'
  import parainput from '@/components/app/customcomp/parainput.vue'
  import dovizinput from '@/components/app/customcomp/dovizinput.vue'
  import genelarama from "@/components/app/coper/comp/genelarama.vue";
  import helpers from "@/components/app/customcomp/helpers.js"
  import rez from "../rezervasyon";
  import kur from "@/components/app/coper/comp/kur.vue";
  import tool from "../tools";
  import loadingcomp from "@/components/app/customcomp/loadingcomp"
  import cariaracomp from '@/components/app/customcomp/cariaracomp.vue'
import Tahsilatdialog from '../../pakettur/tahsilatdialog.vue';



  export default {
    props: ["value"],
    components: {
      tarihcomp,
      parainput,
      dovizinput,
      kur,
      genelarama,
      loadingcomp,
      cariaracomp
    },
    computed: {
      val: {
        get: function () {
          return this.value;
        },
        set: function (newValue) {
          this.$emit('input', newValue)
        },
      },
    },
    beforeMount: beforeMount,
    filters: {

      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },
      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }

    },
    methods: {
      cariislemler1(a) {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'))
        var params = {
          Code: a,
          CompanyCode: credentials.SirketKodu
        }

        this.$http.post(auth.API_URL + 'api/Current/Get', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {




        }, (response) => {
          if (response.status === 0) {
             this.text1 = this.$t(response.body.ResponseMessage)
            this.snackbar = true
          } else {
            this.text1 = response.statusText
            this.snackbar = true
          }
        })


      },
      cariislemler(a) {

        let params = {
          Code: a,
          SummaryInfoShow: false
        }

        tool.http_post(this, 'GetCurrent', params).then(
          response => {
            if (response.body.Status == true) {
              if (this.odeme.OdemeTipi == 0) {
                this.odeme.NakitBilgi.KarsiCari.Unvan2 = response.body.data.Unvani2
                this.odeme.NakitBilgi.KarsiCari.Adres1 = response.body.data.FaturaBilgi.Adres
                this.odeme.NakitBilgi.KarsiCari.Adres2 = response.body.data.FaturaBilgi.Adres2
                this.odeme.NakitBilgi.KarsiCari.VergiDairesi = response.body.data.FaturaBilgi.VergiDairesi
                this.odeme.NakitBilgi.KarsiCari.VergiNo = response.body.data.FaturaBilgi.VergiNo
                this.odeme.NakitBilgi.KarsiCari.TCKimlikNo = response.body.data.FaturaBilgi.TckimlikNo
                this.odeme.NakitBilgi.KarsiCari.Ilce_Il = response.body.data.FaturaBilgi.IlceIl
                this.odeme.NakitBilgi.KarsiCari.EfaturaKayitli = parseInt(response.body.data.EFaturaKayitli)
                this.odeme.NakitBilgi.KarsiCari.PerFirstName = response.body.data.FaturaBilgi.PerFirstName
                this.odeme.NakitBilgi.KarsiCari.PerFamilyName = response.body.data.FaturaBilgi.PerFamilyName
                this.odeme.NakitBilgi.KarsiCari.EMail = response.body.data.Email
              } else {
                this.odeme.NakitBilgi.KarsiCari.Unvan2 = null
                this.odeme.NakitBilgi.KarsiCari.Adres1 = null
                this.odeme.NakitBilgi.KarsiCari.Adres2 = null
                this.odeme.NakitBilgi.KarsiCari.VergiDairesi = null
                this.odeme.NakitBilgi.KarsiCari.VergiNo = null
                this.odeme.NakitBilgi.KarsiCari.TCKimlikNo = null
                this.odeme.NakitBilgi.KarsiCari.Ilce_Il = null
                this.odeme.NakitBilgi.KarsiCari.EfaturaKayitli = null
                this.odeme.NakitBilgi.KarsiCari.PerFirstName = null
                this.odeme.NakitBilgi.KarsiCari.PerFamilyName = null
                this.odeme.NakitBilgi.KarsiCari.EMail = null
              }

              if (this.odeme.OdemeTipi == 1) {
                this.odeme.KrediKartBilgi.KarsiCari.Unvan2 = response.body.data.Unvani2
                this.odeme.KrediKartBilgi.KarsiCari.Adres1 = response.body.data.FaturaBilgi.Adres
                this.odeme.KrediKartBilgi.KarsiCari.Adres2 = response.body.data.FaturaBilgi.Adres2
                this.odeme.KrediKartBilgi.KarsiCari.VergiDairesi = response.body.data.FaturaBilgi.VergiDairesi
                this.odeme.KrediKartBilgi.KarsiCari.VergiNo = response.body.data.FaturaBilgi.VergiNo
                this.odeme.KrediKartBilgi.KarsiCari.TCKimlikNo = response.body.data.FaturaBilgi.TckimlikNo
                this.odeme.KrediKartBilgi.KarsiCari.Ilce_Il = response.body.data.FaturaBilgi.IlceIl
                this.odeme.KrediKartBilgi.KarsiCari.EfaturaKayitli = parseInt(response.body.data.EFaturaKayitli)
                this.odeme.KrediKartBilgi.KarsiCari.PerFirstName = response.body.data.FaturaBilgi.PerFirstName
                this.odeme.KrediKartBilgi.KarsiCari.PerFamilyName = response.body.data.FaturaBilgi.PerFamilyName
                this.odeme.KrediKartBilgi.KarsiCari.EMail = response.body.data.Email
              } else {
                this.odeme.KrediKartBilgi.KarsiCari.Unvan2 = null
                this.odeme.KrediKartBilgi.KarsiCari.Adres1 = null
                this.odeme.KrediKartBilgi.KarsiCari.Adres2 = null
                this.odeme.KrediKartBilgi.KarsiCari.VergiDairesi = null
                this.odeme.KrediKartBilgi.KarsiCari.VergiNo = null
                this.odeme.KrediKartBilgi.KarsiCari.TCKimlikNo = null
                this.odeme.KrediKartBilgi.KarsiCari.Ilce_Il = null
                this.odeme.KrediKartBilgi.KarsiCari.EfaturaKayitli = null
                this.odeme.KrediKartBilgi.KarsiCari.PerFirstName = null
                this.odeme.KrediKartBilgi.KarsiCari.PerFamilyName = null
                this.odeme.KrediKartBilgi.KarsiCari.EMail = null
              }

              if (this.odeme.OdemeTipi == 3) {
                this.odeme.SanalPosBilgi.KarsiCari.Unvan2 = response.body.data.Unvani2
                this.odeme.SanalPosBilgi.KarsiCari.Adres1 = response.body.data.FaturaBilgi.Adres
                this.odeme.SanalPosBilgi.KarsiCari.Adres2 = response.body.data.FaturaBilgi.Adres2
                this.odeme.SanalPosBilgi.KarsiCari.VergiDairesi = response.body.data.FaturaBilgi.VergiDairesi
                this.odeme.SanalPosBilgi.KarsiCari.VergiNo = response.body.data.FaturaBilgi.VergiNo
                this.odeme.SanalPosBilgi.KarsiCari.TCKimlikNo = response.body.data.FaturaBilgi.TckimlikNo
                this.odeme.SanalPosBilgi.KarsiCari.Ilce_Il = response.body.data.FaturaBilgi.IlceIl
                this.odeme.SanalPosBilgi.KarsiCari.EfaturaKayitli = parseInt(response.body.data.EFaturaKayitli)
                this.odeme.SanalPosBilgi.KarsiCari.PerFirstName = response.body.data.FaturaBilgi.PerFirstName
                this.odeme.SanalPosBilgi.KarsiCari.PerFamilyName = response.body.data.FaturaBilgi.PerFamilyName
                this.odeme.SanalPosBilgi.KarsiCari.EMail = response.body.data.Email
              } else {
                this.odeme.SanalPosBilgi.KarsiCari.Unvan2 = null
                this.odeme.SanalPosBilgi.KarsiCari.Adres1 = null
                this.odeme.SanalPosBilgi.KarsiCari.Adres2 = null
                this.odeme.SanalPosBilgi.KarsiCari.VergiDairesi = null
                this.odeme.SanalPosBilgi.KarsiCari.VergiNo = null
                this.odeme.SanalPosBilgi.KarsiCari.TCKimlikNo = null
                this.odeme.SanalPosBilgi.KarsiCari.Ilce_Il = null
                this.odeme.SanalPosBilgi.KarsiCari.EfaturaKayitli = null
                this.odeme.SanalPosBilgi.KarsiCari.PerFirstName = null
                this.odeme.SanalPosBilgi.KarsiCari.PerFamilyName = null
                this.odeme.SanalPosBilgi.KarsiCari.EMail = null
              }
            } else {
              this.text1 = response.body.ErrorList[0]
              this.snackbar = true
            }

          },

          response => {
            this.text1 = 'Hata Oluştu, tekrar deneyiniz'
            this.snackbar = true

          }

        );

      },
      formTemizle() {

        this.cariKodu.KarsiCari.id = ''
        this.cariKodu.KarsiCari.isim = ''
        this.cariKodu.KarsiCari.kod = ''
        this.cariKodu.KarsiCari.isimAra = ''
        this.cariKodu.KarsiCariAciklama = ''

        this.odeme.OdemeTarihi = helpers.getDateNow();
        this.para.kur = 1
        this.para.paraBirimi = 'TL'
        this.odeme.OdemeTipi = 0

        this.odeme.NakitBilgi.KarsiCari.Unvan2 = null
        this.odeme.NakitBilgi.KarsiCari.Adres1 = null
        this.odeme.NakitBilgi.KarsiCari.Adres2 = null
        this.odeme.NakitBilgi.KarsiCari.VergiDairesi = null
        this.odeme.NakitBilgi.KarsiCari.VergiNo = null
        this.odeme.NakitBilgi.KarsiCari.TCKimlikNo = null
        this.odeme.NakitBilgi.KarsiCari.Ilce_Il = null
        this.odeme.NakitBilgi.KarsiCari.EfaturaKayitli = null
        this.odeme.NakitBilgi.KarsiCari.PerFirstName = null
        this.odeme.NakitBilgi.KarsiCari.PerFamilyName = null
        this.odeme.NakitBilgi.KarsiCari.EMail = null
        this.odeme.NakitBilgi.KarsiCariAciklama = null

        this.odeme.KrediKartBilgi.KarsiCari.Unvan2 = null
        this.odeme.KrediKartBilgi.KarsiCari.Adres1 = null
        this.odeme.KrediKartBilgi.KarsiCari.Adres2 = null
        this.odeme.KrediKartBilgi.KarsiCari.VergiDairesi = null
        this.odeme.KrediKartBilgi.KarsiCari.VergiNo = null
        this.odeme.KrediKartBilgi.KarsiCari.TCKimlikNo = null
        this.odeme.KrediKartBilgi.KarsiCari.Ilce_Il = null
        this.odeme.KrediKartBilgi.KarsiCari.EfaturaKayitli = null
        this.odeme.KrediKartBilgi.KarsiCari.PerFirstName = null
        this.odeme.KrediKartBilgi.KarsiCari.PerFamilyName = null
        this.odeme.KrediKartBilgi.KarsiCari.EMail = null
        this.odeme.KrediKartBilgi.KarsiCariAciklama = null
        this.odeme.KrediKartBilgi.FirmaKrediKartli = false

        this.odeme.KrediKartBilgi.KartNo = null
        this.odeme.KrediKartBilgi.KartAdi = null
        this.odeme.KrediKartBilgi.KartTipi = null
        this.odeme.KrediKartBilgi.Banka = null
        this.odeme.KrediKartBilgi.Taksit = 1
        this.odeme.KrediKartBilgi.PosKodu = null
        this.odeme.KrediKartBilgi.PosTaksit = null
        this.odeme.KrediKartBilgi.PuanTutari = 0
        this.odeme.HavaleBilgi.Banka = null
        this.odeme.HavaleBilgi.ciklama = null

        this.odeme.SanalPosBilgi.KarsiCari.Unvan2 = null
        this.odeme.SanalPosBilgi.KarsiCari.Adres1 = null
        this.odeme.SanalPosBilgi.KarsiCari.Adres2 = null
        this.odeme.SanalPosBilgi.KarsiCari.VergiDairesi = null
        this.odeme.SanalPosBilgi.KarsiCari.VergiNo = null
        this.odeme.SanalPosBilgi.KarsiCari.TCKimlikNo = null
        this.odeme.SanalPosBilgi.KarsiCari.Ilce_Il = null
        this.odeme.SanalPosBilgi.KarsiCari.EfaturaKayitli = null
        this.odeme.SanalPosBilgi.KarsiCari.PerFirstName = null
        this.odeme.SanalPosBilgi.KarsiCari.PerFamilyName = null
        this.odeme.SanalPosBilgi.KarsiCari.EMail = null
        this.odeme.SanalPosBilgi.KarsiCariAciklama = null


        this.odeme.Tutar = 0
        this.odeme.ParaBirimi = 'TL'
        this.odeme.Kur = 1
        this.odeme.OdemeIadesi = false
        this.odeme.PNR_No = null
        this.odeme.EvrakNo = null
        this.odeme.Aciklama = null
      },
      getparabirimi() {
        return helpers.getparabirimi()
      },
      taksitgetirtahsilat(v) {
        
        var tumliste = []
        tumliste = this.bankapositems
        tumliste.forEach(element => {
          if (element.PosKodu == v) {
            this.taksitsayitahsilat = []
            this.taksitsayitahsilat = element.Taksitler
          }
        });
      },
      open(title, tutar, data) {

        if (title == 'tahsilat') {
          this.dialogbaslik = this.$t('Add-Collection')
          this.kaydetbuton = true
          this.tahsilatguncellebuton = false

          this.formTemizle();

        }


        if (title == 'update') {
          this.dialogbaslik = 'Tahsilat Güncelle'
          this.yedekodeme = data
          this.tahsilatguncellebuton = true
          this.kaydetbuton = false

          this.formTemizle()

          this.odeme.P_PNR_No = data.detail.PNR_No
          this.odeme.PNR_No=data.detail.PNR_No
          this.odeme.P_HesapKodu = this.val.Rez.cariKod.id
          this.odeme.P_Referans = data.detail.PNR_No
          this.odeme.P_CoKrediKartYuzde = data.yuzde

          // Form kontrollerine görüntülenecek alanları doldur
          this.odeme.OdemeTarihi = data.tarih

          this.odeme.OdemeTipi = data.odemeTipi != null ? data.odemeTipi : 3
          if (data.detail.Evraktipi=='NK' || data.detail.Evraktipi=='NKI'){
            this.odeme.OdemeTipi=0;
            if (data.detail.Evraktipi=='NKI'){
              this.odeme.OdemeIadesi = true;
            }
          }
          if (data.detail.Evraktipi=='KR' || data.detail.Evraktipi=='KRI'){
            this.odeme.OdemeTipi=1;
             if (data.detail.Evraktipi=='KRI'){
              this.odeme.OdemeIadesi = true;
            }
          }
           if (data.detail.Evraktipi=='HV' || data.detail.Evraktipi=='HVI'){
            this.odeme.OdemeTipi=2;
             if (data.detail.Evraktipi=='HVI'){
              this.odeme.OdemeIadesi = true;
            }
          }
            if (data.detail.Evraktipi=='SP' || data.detail.Evraktipi=='SPI'){
            this.odeme.OdemeTipi=3;
             if (data.detail.Evraktipi=='SPI'){
              this.odeme.OdemeIadesi = true;
            }
          }
          this.cariKodu.KarsiCari.kod=data.detail.KarsiCari;
          this.cariKodu.KarsiCariAciklama=data.detail.Karsiaciklama;

          this.odeme.Tutar = data.dovizTutar
          this.odeme.EvrakNo = data.evrakNo
          this.odeme.Aciklama = data.detail.Aciklama

          this.para = { kur: data.para.kur, paraBirimi: data.para.paraBirimi || data.para.ParaBirimi }

          this.odeme.KrediKartBilgi.KartNo = data.detail.CoKrediKartNo
          this.odeme.KrediKartBilgi.KartTipi = data.detail.CoKrediKartTip
          this.odeme.KrediKartBilgi.KartAdi = data.kartAdi
          this.odeme.KrediKartBilgi.PosKodu = data.detail.poskod
          this.odeme.KrediKartBilgi.PosTaksit = data.detail.Taksitposkod
          this.odeme.KrediKartBilgi.PuanTutari=data.detail.puantutar

          this.odeme.HavaleBilgi.Banka = data.hvBankaKod
          this.odeme.HavaleBilgi.Aciklama = data.detail.HVAciklama

          this.taksitgetirtahsilat(this.odeme.KrediKartBilgi.PosKodu)
        }
        this.tahsilatdialog = true;

        return new Promise((resolve, reject) => {
          this.resolve = resolve;
          this.reject = reject;
        });

      },


      tahsilatkaydet: tahsilatkaydet,
      tahsilatvalidate,
      tahsilatguncelle: tahsilatguncelle
    },
    data() {
      return {
        loadingvmodel:false,
        validkredikarti: true,
        validkarsicari: true,
        validhavale: true,
        cariKodu: {
          KarsiCari: {
            id: null,
            isim: null,
            kod: null,
            isimAra: null
          },
          KarsiCariAciklama: null,

        },
        odeme: {
          OdemeTarihi: null,
          OdemeTipi: 0,
          NakitBilgi: {
            KarsiCari: {
              Unvan2: null,
              Adres1: null,
              Adres2: null,
              VergiDairesi: null,
              VergiNo: null,
              TCKimlikNo: null,
              Ilce_Il: null,
              EfaturaKayitli: null,
              PerFirstName: null,
              PerFamilyName: null,
              EMail: null,
              id: "0",
              kod: null,
              isim: null,
              tip: 0
            },
            KarsiCariAciklama: null
          },
          KrediKartBilgi: {
            KarsiCari: {
              Unvan2: null,
              Adres1: null,
              Adres2: null,
              VergiDairesi: null,
              VergiNo: null,
              TCKimlikNo: null,
              Ilce_Il: null,
              EfaturaKayitli: null,
              PerFirstName: null,
              PerFamilyName: null,
              EMail: null,
              id: "0",
              kod: null,
              isim: null,
              tip: 0
            },
            KarsiCariAciklama: null,
            FirmaKrediKartli: false,
            KartNo: null,
            KartAdi: null,
            KartTipi: null,
            Banka: null,
            Taksit: 1,
            PosKodu: null,
            PosTaksit: null,
            PuanTutari: 0
          },
          HavaleBilgi: {
            Banka: null,
            Aciklama: null,
          },
          SanalPosBilgi: {
            KarsiCari: {
              Unvan2: null,
              Adres1: null,
              Adres2: null,
              VergiDairesi: null,
              VergiNo: null,
              TCKimlikNo: null,
              Ilce_Il: null,
              EfaturaKayitli: null,
              PerFirstName: null,
              PerFamilyName: null,
              EMail: null,
              id: "0",
              kod: null,
              isim: null,
              tip: 0
            },
            KarsiCariAciklama: null
          },
          Tutar: 0,
          ParaBirimi: 'TL',
          Kur: 1,
          OdemeIadesi: false,
          PNR_No: null,
          EvrakNo: null,
          Aciklama: null
        },
        yedekodeme: {},
        para: {
          paraBirimi: 0,
          kur: 0,
        },
        sirketlist: [],
        karttipi: [{
            id: 'MASTER',
            text: 'Master Card'
          },
          {
            id: 'VISA',
            text: 'VISA'
          },
          {
            id: 'AmEx',
            text: 'American Express'
          },
        ],
        odemeItems: [{
            text: this.$t('Cash'),
            value: 0
          },
          {
            text: this.$t('Credit-Card'),
            value: 1
          },
          {
            text: this.$t('Transfer-v3'),
            value: 2
          }, {
            text: this.$t('Virtual-POS'),
            value: 3
          },

        ],

        valid: true,
        alertshow: false,
        alertmodel: true,
        tahsilatbakiyem: 0,
        dialogbaslik: '',
        resolve: null,
        kaydetbuton: false,
        tahsilatguncellebuton: false,
        k: null,
        doviztipi: [],
        reject: null,
        bankapositems: [],
        itemsbanka: [],
        statecaritahsilat: [],
        itemsevraktipi: [],
        tahsilatdialog: false,
        text1: null,
        searchcaritahsilat: '',
        taksitsayitahsilat: [],
        loading: false,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
      }
    },

    watch: {
      searchcaritahsilat(val) {
        val && this.carigetir2(val)
      },
      'cariKodu.KarsiCari.kod': function (val) {

        if (val != null && val != '') {
          this.cariislemler(val)
        }

      },

    },
    mounted() {

    }
  }





  function tahsilatvalidate() {
    if (this.$refs.formTahsilat.validate()) {

      if (this.odeme.Tutar > 0) {

        this.odeme.ParaBirimi = this.para.paraBirimi
        this.odeme.Kur = this.para.kur
        this.odeme.PNR_No = this.val.Rez.pNR_No
        
        if (this.odeme.OdemeTipi == 0) {
         
          this.odeme.NakitBilgi.KarsiCari.kod = this.cariKodu.KarsiCari.kod;
          this.odeme.NakitBilgi.KarsiCariAciklama = this.cariKodu.KarsiCariAciklama
             this.tahsilatkaydet();
          // if (this.$refs.formkarsicari.validate()) {
          // }
        }

        if (this.odeme.OdemeTipi == 1) {
          this.odeme.KrediKartBilgi.KarsiCariAciklama = this.cariKodu.KarsiCariAciklama
          this.odeme.KrediKartBilgi.KarsiCari.kod = this.cariKodu.KarsiCari.kod;


          // if (this.$refs.formkarsicari.validate()) {

            if (this.$refs.formkredikarti.validate()) {
              this.tahsilatkaydet();
            }

         // }
        }

        if (this.odeme.OdemeTipi == 2) {
          // if (this.$refs.formhavale.validate()) {
            this.tahsilatkaydet();
          // }


        }


        if (this.odeme.OdemeTipi == 3) {
          this.odeme.SanalPosBilgi.KarsiCari.kod = this.cariKodu.KarsiCari.kod;
          this.odeme.SanalPosBilgi.KarsiCariAciklama = this.cariKodu.KarsiCariAciklama
          // if (this.$refs.formkarsicari.validate()) {
            this.tahsilatkaydet();
          //}
        }


      } else {
        this.text1 = this.$t('Price-Must-be-Greater-than-zero')
        this.snackbar = true
      }
    }
  }

  function tahsilatkaydet() {

        
    // this.odeme.NakitBilgi.KarsiCariAciklama = this.cariKodu.KarsiCariAciklama;
    

    var prm = this.odeme
    if (prm.OdemeTipi==1 && prm.KrediKartBilgi.Taksit==0){
prm.KrediKartBilgi.Taksit=1;
    }
this.loadingvmodel=true
    tool.http_post(this, "OdemeKaydet", prm).then(
      response => {

        this.resolve(true);
        this.loadingvmodel=false
        this.tahsilatdialog = false
        if (response.body.Status == true) {
          this.val.Rez.odemeler = response.body.data
        } else {
          this.text1 = response.body.ErrorList[0]
          this.snackbar = true
        }

      },
      response => {
        this.loadingvmodel=false
        this.status = tool.responseToStatus(response);
      }
    );

  }



  function beforeMount() {


    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      CompanyCode: credentials.CoperSirketNo,
      PosCode: null,
      Search: null,
      Coper: true,
    }

    this.$http.post(auth.API_URL + 'api/BankPos/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.bankapositems = response.body
      this.progress = false
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-bankpos'
        this.progress = false
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-bankpos'
        this.snackbar = true
        this.progress = false
      }
    })


    this.$http.post(auth.API_URL + 'api/Bank/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.itemsbanka = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })

  }
  
 function tahsilatguncelle_yedek() {

    if (this.$refs.formTahsilat.validate()) {

      var prm = {
        P_SirketAdi: this.yedekodeme.sirketAdi,
        P_HesapKodu: this.yedekodeme.hesapKodu,
        P_Tarih: this.yedekodeme.tarih,
        P_SiraNo: this.yedekodeme.siraNo
      }

      tool.http_post(this, "GenelOdemeSil", prm).then(
        response => {

          if (this.sirketlist != null && this.sirketlist != []) {
            this.odeme.P_SirketAdi = this.sirketlist.CariSirketNo
            this.odeme.P_CoSirketNo = this.sirketlist.SirketNo
          }
          // Form kontrollerinden güncel değerleri P_ alanlarına aktar
          this.odeme.P_OdemeTipi = this.odeme.OdemeTipi
          this.odeme.P_Tarih = this.odeme.OdemeTarihi
          this.odeme.P_Vade = this.odeme.OdemeTarihi
          this.odeme.P_DovizTutar = this.odeme.Tutar
          this.odeme.P_evrakno = this.odeme.EvrakNo
          this.odeme.P_Aciklama = this.odeme.Aciklama
          this.odeme.P_Karsiaciklama = this.odeme.Aciklama
          this.odeme.P_DovizCinsi = this.para.paraBirimi
          this.odeme.P_Kur = this.para.kur
          this.odeme.P_KrediKartNo = this.odeme.KrediKartBilgi.KartNo
          this.odeme.P_CoKrediKartTip = this.odeme.KrediKartBilgi.KartTipi
          this.odeme.P_CoKrediKartKod = this.odeme.KrediKartBilgi.KartAdi
          this.odeme.P_CoKrediKartBanka = this.odeme.KrediKartBilgi.PosKodu
          this.odeme.P_CoKrediKartTaksit = this.odeme.KrediKartBilgi.PosTaksit
          this.odeme.P_bankakod = this.odeme.HavaleBilgi.Banka
          this.odeme.P_HvAciklama = this.odeme.HavaleBilgi.Aciklama
          
          var prm1 = this.odeme

          tool.http_post(this, "OdemeKaydet", prm1).then(
            response => {

              this.resolve(true);
              this.tahsilatdialog = false

              if (response.body.Status == true) {

              }

            },
            response => {
              this.status = tool.responseToStatus(response);
            }
          );
        },
        response => {
          this.status = tool.responseToStatus(response);
        }
      );


    }

  }

  function tahsilatguncelle() {

    if (this.$refs.formTahsilat.validate()) {

      if (this.sirketlist != null && this.sirketlist != []) {
        this.odeme.P_SirketAdi = this.sirketlist.CariSirketNo
        this.odeme.P_CoSirketNo = this.sirketlist.SirketNo
      }
      // Form kontrollerinden güncel değerleri P_ alanlarına aktar
      this.odeme.P_OdemeTipi = this.odeme.OdemeTipi
      this.odeme.P_Tarih = this.odeme.OdemeTarihi
      this.odeme.P_Vade = this.odeme.OdemeTarihi
      this.odeme.P_DovizTutar = this.odeme.Tutar
      this.odeme.P_evrakno = this.odeme.EvrakNo
      this.odeme.P_Aciklama = this.odeme.Aciklama
      this.odeme.P_Karsiaciklama = this.odeme.Aciklama
      this.odeme.P_DovizCinsi = this.para.paraBirimi
      this.odeme.P_Kur = this.para.kur
      this.odeme.P_KrediKartNo = this.odeme.KrediKartBilgi.KartNo
      this.odeme.P_CoKrediKartTip = this.odeme.KrediKartBilgi.KartTipi
      this.odeme.P_CoKrediKartKod = this.odeme.KrediKartBilgi.KartAdi
      this.odeme.P_CoKrediKartBanka = this.odeme.KrediKartBilgi.PosKodu
      this.odeme.P_CoKrediKartTaksit = this.odeme.KrediKartBilgi.PosTaksit
      this.odeme.P_bankakod = this.odeme.HavaleBilgi.Banka
      this.odeme.P_HvAciklama = this.odeme.HavaleBilgi.Aciklama

      tool.http_post(this, "OdemeKaydet", this.odeme).then(
        response => {

          if (response.body.Status == true) {
            var prmSil = {
              P_SirketAdi: this.yedekodeme.sirketAdi,
              P_HesapKodu: this.yedekodeme.hesapKodu,
              P_Tarih: this.yedekodeme.tarih,
              P_SiraNo: this.yedekodeme.siraNo
            }

            tool.http_post(this, "GenelOdemeSil", prmSil).then(
              response => {
                this.resolve(true);
                this.tahsilatdialog = false
              },
              response => {
                this.status = tool.responseToStatus(response);
              }
            );
          } else {
            this.text1 = response.body.ErrorList ? response.body.ErrorList[0] : 'Güncelleme başarısız'
            this.snackbar = true
          }

        },
        response => {
          this.status = tool.responseToStatus(response);
        }
      );


    }

  }
</script>